import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const MisHoliday = Loadable(lazy(() => import("./Misholiday.jsx")));
const MisEditHoliday = Loadable(lazy(() => import("./MisEditHoliday.jsx")));
const MisAddHoliday = Loadable(lazy(() => import("./MisAddHoliday.jsx")));

const MisHolidayRoutes = [
    { path: "/mis-holiday", element: <MisHoliday/> },
    { path: "/edit-misholiday", element: <MisEditHoliday/> },
    { path: "/add-misholiday", element: <MisAddHoliday/> },
];

export default MisHolidayRoutes;